import { render, staticRenderFns } from "./UserBuyAgreeDialog.vue?vue&type=template&id=2ff4799a&scoped=true"
import script from "./UserBuyAgreeDialog.vue?vue&type=script&lang=js"
export * from "./UserBuyAgreeDialog.vue?vue&type=script&lang=js"
import style0 from "./UserBuyAgreeDialog.vue?vue&type=style&index=0&id=2ff4799a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4799a",
  null
  
)

export default component.exports